// B2B Layout Component
import { Outlet, Navigate } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';
import B2BHeader from './B2BHeader';
import B2BSidebar from './B2BSidebar';

export default function B2BLayout() {
  const { isAuthenticated, loading } = useB2B();

  // Show loading state
  if (loading) {
    return (
      <div className="b2b-login-page">
        <div className="b2b-loading">
          <div className="b2b-spinner" />
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/b2b/login" replace />;
  }

  return (
    <div className="b2b-layout">
      <B2BSidebar />
      <div className="b2b-main">
        <Outlet />
      </div>
    </div>
  );
}
